import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { remindPassword } from '../../api/customer';

interface RemindPasswordFormData {
    email: string;
}

export default function RemindPassword({close, onBack}: {close: () => void, onBack: () => void}) {
    const { register, handleSubmit, formState: { errors } } = useForm<RemindPasswordFormData>();
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const onSubmit = async (data: RemindPasswordFormData) => {
        setErrorMessage('');
        setSuccessMessage('');
        setIsSubmitting(true);
        try {
            const response = await remindPassword(data.email);
            if (response.status === 'false' || response.status === false) {
                setErrorMessage((response as any).error || 'Ошибка при отправке запроса');
            } else {
                setSuccessMessage(response.message || 'Инструкции по восстановлению пароля отправлены на указанный email');
            }
        } catch (error: any) {
            setErrorMessage(error.response?.data?.error || error.response?.data?.message || error.message || 'Ошибка при отправке запроса');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (<div className={"modal show"} onClick={close}>
        <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex flex-column modal-content">
                <div className="d-flex flex-column modal-box modal-header">
                    <button type="button" className="btn-close"
                            aria-label="Закрыть" onClick={close}></button>
                    <div className="fw-bold modal-title">Восстановление пароля</div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {errorMessage && (
                        <div className="d-flex flex-column modal-box modal-body">
                            <div className="alert alert-danger" role="alert">
                                {errorMessage}
                            </div>
                        </div>
                    )}
                    {successMessage && (
                        <div className="d-flex flex-column modal-box modal-body">
                            <div className="alert alert-success" role="alert">
                                {successMessage}
                            </div>
                        </div>
                    )}
                    {!successMessage && (
                        <div className="d-flex flex-column modal-box modal-body">
                            <div className="form-control-item">
                                <input
                                    type="email"
                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                    placeholder="Электронная почта"
                                    {...register('email', {
                                        required: 'Email обязателен',
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: 'Некорректный email'
                                        }
                                    })}
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                            </div>
                        </div>
                    )}
                    <div className="d-flex flex-column modal-box mt-3">
                        {!successMessage && (
                            <button type="submit" className="btn btn-primary modal-btn two" disabled={isSubmitting}>
                                {isSubmitting ? 'Отправка...' : 'Отправить'}
                            </button>
                        )}
                        {successMessage ? (
                            <button type="button" className="btn btn-primary modal-btn two" onClick={onBack}>
                                Авторизоваться
                            </button>
                        ) : (
                            <button type="button" className="btn btn-link mt-2" onClick={onBack}>
                                Вернуться к авторизации
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    </div>)
}
